export enum PROJECTS {
   CRYPTOCURRENCY_MARKET = "Cryptocurrency.Market",
   KINGS_AND_ALLIES = "KingsAndAllies"
}
export enum ASSISTANT {
   AssistantName = "Tai Zen Ai",
   Version = "v0.0.0",
   collectionName = "TaiZenAssistantDefault",
   kingsAndAllies = PROJECTS.KINGS_AND_ALLIES,
   cryptocurrencyMarket = PROJECTS.CRYPTOCURRENCY_MARKET
}
export enum CollectionName {
   PERSONA_TRAITS = "PersonaTraits",
   CHUNK = "Chunk",
   SUMMARY = "Summary",
   QA = "QA"
}
export enum PersonaContentType {
   TRAIT = "trait",
   EXAMPLE = "example"
}

/** Knowledge collections that store project-scoped data */
export const KNOWLEDGE_COLLECTIONS = [
   CollectionName.CHUNK,
   CollectionName.SUMMARY,
   CollectionName.QA
] as const;
export enum MAX_SIZE_FILE {
   UPLOAD_MB = 100
}
export enum MILVUS_ACTIONS {
   CHAT = "CHAT",
   BACKUP = "BACKUP",
   RESTORE = "RESTORE",
   CHAT_VECTOR = "CHAT-VECTOR",
   CREATE_COLLECTION = "CREATE-COLLECTION",
   INSERT_DATA = "INSERT-DATA",
   GENERATE_EMBEDDINGS = "GENERATE-EMBEDDINGS"
}

export enum CONFIG_ACTIONS {
   SET = "SET",
   DELETE = "DELETE",
   GET_ALL = "GET_ALL",
   REVERT = "REVERT"
}

export enum EMBEDDING_TYPE {
   OPENAI = "OPENAI",
   OLLAMA = "OLLAMA"
}

export enum STORAGE_KEYS {
   SELECTED_MODEL = "selectedModel",
   USER = "user",
   SCROLL_BUTTON_PINNED = "scrollButtonPinned",
   SCROLL_BUTTON_POSITION = "scrollButtonPosition"
}
export enum METHOD_TYPE {
   GET = "GET",
   POST = "POST",
   PUT = "PUT",
   DELETE = "DELETE",
   PATCH = "PATCH"
}

export enum ATTACHMENT_PIPELINE_STATUS {
   AWAITING_UPLOAD = "awaiting-upload",
   QUEUED = "queued",
   SCANNING = "scanning",
   VALIDATING = "validating",
   EXTRACTING = "extracting",
   READY = "ready",
   REJECTED = "rejected",
   FAILED = "failed"
}

export enum GRAPHQL_ERROR_CODE {
   UNAUTHENTICATED = "UNAUTHENTICATED",
   FORBIDDEN = "FORBIDDEN",
   NOT_FOUND = "NOT_FOUND",
   VALIDATION_ERROR = "VALIDATION_ERROR",
   PIN_LIMIT_EXCEEDED = "PIN_LIMIT_EXCEEDED"
}

export enum KA_POST_STATUS {
   COLLECTING = "collecting",
   CLOSED = "closed",
   SKIPPED = "skipped",
   DRAFTING = "drafting",
   READY = "ready",
   PUBLISHING = "publishing",
   PUBLISHED = "published",
   REJECTED = "rejected",
   FAILED = "failed",
   UNPUBLISHED = "unpublished",
   CONFLICT = "conflict"
}

export enum KA_FACEBOOK_STATUS {
   PENDING = "pending",
   SHARING = "sharing",
   SHARED = "shared",
   FAILED = "failed",
   REMOVED = "removed"
}

export enum KA_FACEBOOK_PAGE_STATE {
   OFF = "off",
   MISSING_CREDENTIALS = "missing_credentials",
   CONNECTED = "connected",
   ERROR = "error"
}

export enum KA_POST_ACTION {
   APPROVE = "approve",
   REJECT = "reject",
   DRAFT = "draft",
   UNPUBLISH = "unpublish",
   APPROVE_MANY = "approve_many",
   UPDATE_DRAFT = "update_draft",
   DISCARD_DRAFT_EDITS = "discard_draft_edits",
   REGENERATE_DRAFT = "regenerate_draft",
   SET_TARGETS = "set_targets",
   RETRY_FACEBOOK_SHARE = "retry_facebook_share",
   REMOVE_FACEBOOK_SHARE = "remove_facebook_share",
   UPDATE_FACEBOOK_CAPTION = "update_facebook_caption",
   REVIEW = "review",
   DELETE = "delete"
}

export enum KA_HEADLINE_SCOPE {
   TITLE_ONLY = "title_only",
   HOOK_ONLY = "hook_only"
}

export enum KA_TENANT {
   KINGS_AND_ALLIES = "kingsAndAllies",
   CRYPTOCURRENCY_MARKET = "cryptocurrencyMarket"
}

export enum KA_SORT_ORDER {
   DESC = "desc",
   ASC = "asc"
}

export enum KA_POST_MODE {
   OFF = "off",
   SHADOW = "shadow",
   DRAFT = "draft",
   PUBLISH = "publish"
}

export enum KA_START_MODE {
   DEFAULT = "default",
   BEGINNING = "beginning",
   DATETIME = "datetime"
}

export enum KA_POSTS_SUB_TAB {
   QUEUE = "queue",
   SKIPPED = "skipped",
   PUBLISHED = "published",
   SETTINGS = "settings"
}
export enum KEY {
   Enter = "Enter",
   ArrowUp = "ArrowUp",
   ArrowDown = "ArrowDown",
   ArrowLeft = "ArrowLeft",
   ArrowRight = "ArrowRight",
   Backspace = "Backspace",
   Delete = "Delete",
   Tab = "Tab",
   Escape = "Escape",
   Space = "Space",
   Shift = "Shift",
   Control = "Control",
   Alt = "Alt",
   Meta = "Meta",
   CapsLock = "CapsLock",
   NumLock = "NumLock",
   ScrollLock = "ScrollLock",
   PrintScreen = "PrintScreen",
   Pause = "Pause",
   Insert = "Insert",
   Home = "Home",
   End = "End",
   PageUp = "PageUp",
   PageDown = "PageDown",
   F1 = "F1",
   F2 = "F2",
   F3 = "F3",
   F4 = "F4",
   F5 = "F5",
   F6 = "F6",
   F7 = "F7",
   F8 = "F8",
   F9 = "F9",
   F10 = "F10",
   F11 = "F11",
   F12 = "F12",
   F13 = "F13",
   F14 = "F14",
   F15 = "F15",
   F16 = "F16",
   F17 = "F17",
   F18 = "F18",
   F19 = "F19",
   F20 = "F20",
   F21 = "F21",
   F22 = "F22",
   F23 = "F23",
   F24 = "F24",
   Comma = ",",
   Period = ".",
   Slash = "/",
   Backquote = "`",
   Semicolon = ";",
   Quote = "'",
   BracketLeft = "[",
   BracketRight = "]",
   Backslash = "\\",
   Minus = "-",
   Equal = "="
}

export enum MIDDLEWARE {
   CALLBACK_URL = "callbackUrl"
}
export enum RETRIEVAL_EVALUATION {
   ACTION_CREATE_TEST_CASE = "CREATE_TEST_CASE",
   ACTION_SAVE_EVALUATION = "SAVE_EVALUATION",
   ACTION_RUN_TEST = "RUN_TEST",
   ACTION_ADD_MISSING_DOC = "ADD_MISSING_DOC",
   ACTION_SEARCH_TEST_CASES = "SEARCH_TEST_CASES",
   ACTION_DELETE_TEST_CASE = "DELETE_TEST_CASE"
}

export enum MEMORY_EVALUATION_ACTIONS {
   CREATE_SUITE = "createSuite",
   UPSERT_TEST_CASE = "upsertTestCase"
}

export enum MEMORY_EVALUATION_RESOURCES {
   SUITES = "suites",
   TEST_CASES = "test-cases",
   RUNS = "runs"
}

export enum MEMORY_EVALUATION_PHASE {
   MEMORY_SUMMARY = "memory-summary",
   CHAT_QUALITY = "chat-quality"
}

export enum MEMORY_EVIDENCE_STATUS {
   FOUND_FIRST_PASS = "FOUND_FIRST_PASS",
   FOUND_AFTER_RETRY = "FOUND_AFTER_RETRY",
   NO_MEMORY_EVIDENCE = "NO_MEMORY_EVIDENCE",
   INVALID_EVIDENCE = "INVALID_EVIDENCE",
   EXTRACTION_FAILED = "EXTRACTION_FAILED",
   NOT_ANALYZED = "NOT_ANALYZED"
}

export enum MEMORY_EVALUATION_STREAM_TYPE {
   START = "start",
   PROGRESS = "progress",
   TEST_CASE_COMPLETE = "testCaseComplete",
   TEST_CASE_ERROR = "testCaseError",
   V2_STEP_START = "V2_STEP_START",
   V2_STEP_COMPLETE = "V2_STEP_COMPLETE",
   ERROR = "error",
   COMPLETE = "complete",
   CHAT_QUALITY_START = "chatQualityStart",
   CHAT_QUALITY_QUESTION_PROGRESS = "chatQualityQuestionProgress",
   CHAT_QUALITY_QUESTION_COMPLETE = "chatQualityQuestionComplete",
   CHAT_QUALITY_CASE_COMPLETE = "chatQualityCaseComplete",
   CHAT_QUALITY_CASE_ERROR = "chatQualityCaseError",
   CHAT_QUALITY_COMPLETE = "chatQualityComplete"
}

export enum DOCUMENT_PROCESSING_ACTIONS {
   PARSE_FILE = "parseFile",
   PROCESS_WITH_AI = "processWithAI",
   EXTRACT_TEXT = "extractText",
   PROCESS_CHUNKS = "processChunks",
   LIST_BATCHES = "listBatches",
   GET_BATCH = "getBatch",
   GET_BATCH_FILE_CONTENT = "getBatchFileContent",
   REGENERATE_BATCH = "regenerateBatch",
   TRANSLATE_BATCH = "translateBatch"
}

export enum CHUNK_STATUS {
   PENDING = "pending",
   COMPLETED = "completed",
   FAILED = "failed",
   PROCESSING = "processing"
}
export enum SemanticChunkingStreamType {
   CHUNK = "chunk",
   CONNECTION = "connection",
   PROGRESS = "progress",
   MEMORY_INFO = "memory_info",
   SUMMARY = "summary",
   ERROR = "error",
   COMPLETE = "complete"
}
export enum DOMAIN {
   CREDIBLE_STAGING_FRONTEND = "staging.credible.social",
   CREDIBLE_STAGING_API = "stagingapi.credible.social",
   CREDIBLE_PRODUCTION_FRONTEND = "credible.social",
   CRYPTOCURRENCY_MARKET = "cryptocurrency.market",
   CREDIBLE_PRODUCTION_API = "productionapi.credible.social",
   CRYPTOCURRENCY_MARKET_FRONTEND = "taizenai.cryptocurrency.market",
   CRYPTOCURRENCY_MARKET_PRODUCTION_API = "prodapi.cryptocurrency.market",
   CRYPTOCURRENCY_MARKET_STAGING_FRONTEND = "taizenai-staging.cryptocurrency.market",
   CRYPTOCURRENCY_MARKET_STAGING_API = "stagingapi.cryptocurrency.market",
   KINGS_AND_ALLIES_STAGING_FRONTEND = "taizenai-staging.kingsandallies.com",
   KINGS_AND_ALLIES_PRODUCTION_FRONTEND = "taizenai.kingsandallies.com",
   KINGS_AND_ALLIES = "kingsandallies.com",
   LOCAL_FRONTEND = "localhost:3000",
   CRYPTOCURRENCY_MARKET_LOCAL_FRONTEND = "taizenai.cryptocurrency.test",
   KINGS_AND_ALLIES_LOCAL_FRONTEND = "taizenai.kingsandallies.test",
   CRYPTOCURRENCY_MARKET_LOCAL = "cryptocurrency.test",
   KINGS_AND_ALLIES_LOCAL = "kingsandallies.test"
}
export enum TENANT_ID {
   CRYPTOCURRENCY_MARKET = 1,
   KINGS_AND_ALLIES = 2
}
export enum ENVIRONMENT {
   DEVELOPMENT = "development",
   STAGING = "staging",
   PRODUCTION = "production"
}
export enum TAI_FU_30_INDEX_CODE {
   ALLCOIN_8020 = "ALLCOIN_8020",
   ALLCOIN_7030 = "ALLCOIN_7030",
   ALLCOIN_6040 = "ALLCOIN_6040",
   ALLCOIN = "ALLCOIN",
   ALTCOIN_8020 = "ALTCOIN_8020",
   DEFI_8020 = "DEFI_8020",
   BTCDominance = "BTCDominance"
}
export enum FUNCTION_NAME_ENUM {
   getTop30CoinsTaiFuIndexByIndex = "getTop30CoinsTaiFuIndexByIndex",
   getTaiFuIndexTypes = "getTaiFuIndexTypes",
   getTaiFu30CryptoIndexChartData = "getTaiFu30CryptoIndexChartData",
   getSpecificCoinChartData = "getSpecificCoinChartData",
   getCoinMarketData = "getCoinMarketData",
   getTopGainersLosers = "getTopGainersLosers",
   searchCoin = "searchCoin",
   getHistoryCycles = "getHistoryCycles",
   getCurrentCryptoCycle = "getCurrentCryptoCycle"
}
export enum SEARCH_TYPE {
   SEMANTIC = "semantic",
   FULLTEXT = "fulltext",
   HYBRID = "hybrid"
}

export enum FEEDBACK_RESOLUTION_STATUS {
   OPEN = "open",
   IN_PROGRESS = "in_progress",
   RESOLVED = "resolved",
   WONT_FIX = "wont_fix",
   DUPLICATE = "duplicate"
}

export enum FEEDBACK_PRIORITY {
   LOW = "low",
   MEDIUM = "medium",
   HIGH = "high"
}

export enum FEEDBACK_RESOLUTION_ACTION {
   INSERT_CHUNK = "insert_chunk",
   EDIT_CHUNK = "edit_chunk",
   DELETE_CHUNK = "delete_chunk",
   INSERT_SUMMARY = "insert_summary",
   EDIT_SUMMARY = "edit_summary",
   DELETE_SUMMARY = "delete_summary",
   INSERT_QA = "insert_qa",
   EDIT_QA = "edit_qa",
   DELETE_QA = "delete_qa",
   INSERT_PERSONA_TRAIT = "insert_persona_trait",
   UPDATE_PERSONA_TRAIT = "update_persona_trait",
   DELETE_PERSONA_TRAIT = "delete_persona_trait",
   UPDATE_CONFIG = "update_config",
   MANUAL_NOTE = "manual_note",
   DEEP_EVALUATION = "deep_evaluation",
   APPLY_DEEP_EVALUATION = "apply_deep_evaluation"
}

export enum FEEDBACK_LLM_ASSIST_ACTION {
   TRIAGE_METADATA = "triage_metadata",
   DEEP_EVALUATION = "deep_evaluation"
}

export enum ATTACHMENT_KIND {
   IMAGE = "image",
   DOCUMENT = "document",
   AUDIO = "audio"
}

export enum EXTRACTION_STATUS {
   PENDING = "pending",
   COMPLETED = "completed",
   FAILED = "failed"
}

export enum INSIGHT_OUTCOME {
   RESOLVED = "resolved",
   UNRESOLVED = "unresolved",
   UNCLEAR = "unclear"
}

export enum INSIGHT_FAILURE_TYPE {
   WRONG_ANSWER = "wrong_answer",
   INCOMPLETE = "incomplete",
   OFF_TOPIC = "off_topic",
   ASKED_AGAIN = "asked_again",
   LANGUAGE_MISMATCH = "language_mismatch",
   NOT_SPECIFIC = "not_specific",
   OTHER = "other"
}

export const FEEDBACK_SYSTEM_LABELS = {
   KB_MISSING: "kb-missing",
   KB_INCOMPLETE: "kb-incomplete",
   KB_OUTDATED: "kb-outdated",
   BAD_RETRIEVAL: "bad-retrieval",
   HALLUCINATION: "hallucination",
   WRONG_TONE: "wrong-tone",
   FIVE_STAR_PROMOTE: "5-star-promote"
} as const;
